import Elemento from "./Elemento.js";

export default class Coleccion extends Elemento {
  constructor() {
    super();
    this.sides = new Array();
    this.sideSel = {};
  }
}
